import React, { Component } from 'react';
import './Option.css';

class Option extends Component {
    constructor(){
        super()
    }
    render(){
        return(
            <div className="container">
                <div  className="item">
                    <label>
                        <input className = "radio"
                            type="radio"
                            name="option"
                            value={this.props.name}
                            checked={this.props.fave === this.props.name}
                            onChange={this.props.handleChange}
                        />
                        <a>{this.props.name}</a><br/>
                    </label>
                </div>
            </div>
            )
    }
}
export default Option


// WEBPACK FOOTER //
// ./src/Option.js